module.exports = __webpack_public_path__ + "static/media/Background.36d1289a.md";